module.exports = __webpack_public_path__ + "img/Skirt-Back-B9-Fc.781a6ec0.png";